export default function HamburgerIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 26 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 1H26" />
      <path d="M0 9.125H26" />
      <path d="M0 17.25H26" />
    </svg>
  )
}
